import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Dashboard from '../views/Dashboard.vue'
import DashAmm from '../views/DashAmm.vue'
import TipologiaPratica from '../views/TipologiaPratica.vue'
import Login from '../views/Login.vue'
import Utenti from '../components/common/Utenti.vue'
import PersoneFisiche from '../views/PersoneFisiche'
import PersoneGiuridiche from '../views/PersoneGiuridiche'
import Pratiche from '../views/Pratiche'
import Protocollo from '../views/Protocollo'
import Terreno from '../views/Terreni'
import PagamentiRuoli from '../views/PagamentiRuoli.vue'




const routes = [
    {path: '/login',  name: 'Login',    component: Login},
    {path: '/dashboard',  name: 'Dashboard',    component: Dashboard},
    {path: '/dashamm',  name: 'DashAmm',    component: DashAmm},
    {path: '/PersoneFisiche',  name: 'PersoneFisiche',    component: PersoneFisiche},
    {path: '/PersoneGiuridiche',  name: 'PersoneGiuridiche',    component: PersoneGiuridiche},
    {path: '/Pratiche',  name: 'Pratiche',    component: Pratiche},
    {path: '/TipologiaPratica',  name: 'TipologiaPratiche',    component: TipologiaPratica},
    {path: '/Protocollo',  name: 'Protocollo',    component: Protocollo},
    {path: '/Terreni',  name: 'Terreno',    component: Terreno},
    {path: '/PagamentiRuoli',  name: 'PagamentiRuoli',    component: PagamentiRuoli},
    {path: '/Utenti',  name: 'Utenti',    component: Utenti},
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
